export default {
	BEFORE_REQUEST: 'BEFORE_REQUEST',
	AFTER_REQUEST: 'AFTER_REQUEST',
	
	BEFORE_COUNTERS_REQUEST: 'BEFORE_COUNTERS_REQUEST',
	AFTER_COUNTERS_REQUEST: 'AFTER_COUNTERS_REQUEST',

	BEFORE_PRODUCTS_REQUEST: 'BEFORE_PRODUCTS_REQUEST',
	AFTER_PRODUCTS_REQUEST: 'AFTER_PRODUCTS_REQUEST',

	BEFORE_MAP_REQUEST: 'BEFORE_MAP_REQUEST',
	AFTER_MAP_REQUEST: 'AFTER_MAP_REQUEST',

	BEFORE_GEO_DATA_REQUEST: 'BEFORE_GEO_DATA_REQUEST',
	AFTER_GEO_DATA_REQUEST: 'AFTER_GEO_DATA_REQUEST',

	BEFORE_START_DATES_REQUEST: 'BEFORE_START_DATES_REQUEST',
	AFTER_START_DATES_REQUEST: 'AFTER_START_DATES_REQUEST',

	BEFORE_END_DATES_REQUEST: 'BEFORE_END_DATES_REQUEST',
	AFTER_END_DATES_REQUEST: 'AFTER_END_DATES_REQUEST',
}